module.exports = __webpack_public_path__ + "media/customizations/lmws/logo-new-d074149963eb7542178dac1ed968df1d.png";